var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadarLogoMock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.0007 94.7917C74.7384 94.7917 94.7923 74.7378 94.7923 50C94.7923 25.2623 74.7384 5.20837 50.0007 5.20837C25.2629 5.20837 5.20898 25.2623 5.20898 50C5.20898 74.7378 25.2629 94.7917 50.0007 94.7917Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0583 30.3749C18.1168 37.1573 15.9152 45.554 16.8933 53.8885C17.8713 62.223 21.9569 69.8819 28.3343 75.3361C34.7118 80.7902 42.9117 83.6383 51.297 83.3117C59.6823 82.985 67.6359 79.5076 73.5697 73.5738C79.5035 67.64 82.9808 59.6865 83.3075 51.3012C83.6342 42.9159 80.7861 34.7159 75.3319 28.3385C69.8777 21.961 62.2188 17.8754 53.8844 16.8974C45.5499 15.9194 37.1532 18.1209 30.3708 23.0624",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1235 60.4167C30.239 57.1921 29.2625 53.5175 29.2978 49.7827C29.3331 46.0479 30.3788 42.3924 32.324 39.204C34.2691 36.0156 37.0412 33.4132 40.346 31.6731C43.6508 29.933 47.3651 29.12 51.0946 29.3205C54.8241 29.5209 58.4299 30.7273 61.5291 32.8116C64.6284 34.8959 67.1056 37.7803 68.6978 41.1588C70.29 44.5374 70.9379 48.2839 70.5727 52.001C70.2075 55.718 68.8429 59.2668 66.6235 62.2709M62.186 66.6667C58.939 69.0512 55.0663 70.4358 51.0435 70.6504C47.0206 70.8651 43.0226 69.9005 39.5402 67.875",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9596 59.2292C55.0568 59.2292 59.1888 55.0972 59.1888 50C59.1888 44.9029 55.0568 40.7709 49.9596 40.7709C44.8625 40.7709 40.7305 44.9029 40.7305 50C40.7305 55.0972 44.8625 59.2292 49.9596 59.2292Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4408 31.6458C29.3172 31.6458 31.6491 29.3139 31.6491 26.4375C31.6491 23.561 29.3172 21.2291 26.4408 21.2291C23.5643 21.2291 21.2324 23.561 21.2324 26.4375C21.2324 29.3139 23.5643 31.6458 26.4408 31.6458Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5228 69.6458C38.3993 69.6458 40.7311 67.3139 40.7311 64.4375C40.7311 61.561 38.3993 59.2291 35.5228 59.2291C32.6463 59.2291 30.3145 61.561 30.3145 64.4375C30.3145 67.3139 32.6463 69.6458 35.5228 69.6458Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M64.3965 67.5834C66.1224 67.5834 67.5215 66.1843 67.5215 64.4584C67.5215 62.7325 66.1224 61.3334 64.3965 61.3334C62.6706 61.3334 61.2715 62.7325 61.2715 64.4584C61.2715 66.1843 62.6706 67.5834 64.3965 67.5834Z",
    stroke: "#11A0DA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadarLogoMock);
export default __webpack_public_path__ + "static/media/radar-logo-mock.d48341b044b8ec1002737c45a677b597.svg";
export { ForwardRef as ReactComponent };